
import { func } from '../../main';
import axios from '../../api'
import router from '../../router';

const state = {
    UserPresenceList: [],
    UserPresenceListForMap: [],
    DepartureListForRef: [],
    ArrivalListForRef: [],
    UserPresenceNoMoreData: false,
    Loading: false,
    UpdateUserPresenceList: true,

};


const getters = {
    GetUserPresenceList(state: any) {
        return state.UserPresenceList;
    },
    GetUserPresenceListForMap(state: any) {
        return state.UserPresenceListForMap;
    },
    GetUserPresenceNoMoreData(state: any) {
        return state.UserPresenceNoMoreData;
    },
    GetUpdateUserPresenceList(state: any) {
        return state.UpdateUserPresenceList;
    },
    GetDepartureListForRef(state: any) {
        return state.DepartureListForRef;
    },
    GetArrivalListForRef(state: any) {
        return state.ArrivalListForRef;
    }
};

const mutations = {

    SetUserPresenceList(state: any, list: any) {
        state.UserPresenceList = list;
    },
    SetUserPresenceListForMap(state: any, list: any) {
        state.UserPresenceListForMap = list;
    },
    AddUserPresenceList(state: any, list: any) {
        state.UserPresenceList = state.UserPresenceList.concat(list);
    },
    SetUserPresenceNoMoreData(state: any, val: any) {
        state.UserPresenceNoMoreData = val;
    },
    SetUpdateUserPresenceList(state: any, val: any) {
        state.UpdateUserPresenceList = val;
    },
    SetDepartureListForRef(state: any, val: any) {
        state.DepartureListForRef = val;
    },
    SetArrivalListForRef(state: any, val: any) {
        state.ArrivalListForRef = val;
    }

};

const actions = {
    GetUserPresenceListFromServer(context: any, Filter: any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("UserPresence/GetUserPresenceList", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey: Filter.searchKey,
                userId: Filter.userId,
                selfUser: true
            }
        })
            .then(data => {
                context.commit("SetLoading", false);
                context.commit('SetUpdateUserPresenceList', false);
                if (data.data.length < 1) {
                    context.commit("SetUserPresenceNoMoreData", true);
                    if (Filter.pageId == 1) {
                        context.commit("SetUserPresenceList", data.data);
                    }
                    return;
                }
                if (Filter.pageId == 1) {
                    context.commit("SetUserPresenceNoMoreData", false);
                    context.commit("SetUserPresenceList", data.data);
                }
                else {
                    context.commit("SetUserPresenceNoMoreData", false);
                    context.commit("AddUserPresenceList", data.data);
                }
            });
    },
    GetUserPresenceListForMapFromServer(context: any, Filter: any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("UserPresence/GetUserPresenceListForMap", {
            params: {
                date: Filter.date,
                userId: Filter.userId
            }
        })
            .then(data => {
                context.commit("SetLoading", false);

                context.commit("SetUserPresenceListForMap", data.data);
            });
    },
    GetArrivalListForRef(context: any, Filter: any) {
        context.commit("SetLoading", true);
        axios.get("UserPresence/GetListForRef", {
            params: {
                id: Filter.id,
                removedId: Filter.removedId,
                data: Filter.data,
                text: Filter.text,
                isOnlyView: Filter.isOnlyView,
            }
        })
            .then(data => {
                context.commit("SetLoading", false);

                context.commit("SetArrivalListForRef", data.data);
            });
    },



    GetDepartureListForRef(context: any, Filter: any) {
        context.commit("SetLoading", true);
        axios.get("UserPresence/GetListForRef", {
            params: {
                id: Filter.id,
                removedId: Filter.removedId,
                data: Filter.data,
                text: Filter.text,
                isOnlyView: Filter.isOnlyView,
                typeExit:true
            }
        })
            .then(data => {
                context.commit("SetLoading", false);
                context.commit("SetDepartureListForRef", data.data);
            });
    },

    ClearUserPresenceList(context: any) {
        context.commit("SetUserPresenceList", []);
    },

    CreateUserPresence(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('UserPresence/UserPresenceCreate', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                context.commit('SetUpdateUserPresenceList', true);
                if (item.goBack) {
                    if (!item.isAutomatic)
                        router.go(-1);
                }
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    CreateUserPresenceAutomatic(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('UserPresence/UserPresenceCreate', item).then((response: any) => {
            console.log(response);

            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditUserPresence(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('UserPresence/UserPresenceCreate', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                alert(res.join('\n'));
            }
            else {
                context.commit('SetUpdateUserPresenceList', true);
                router.go(-1);
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
